import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingInvoicesRedirectComponent } from './billing-invoices-redirect.component';

const routes: Routes = [{
  path: '',
  component: BillingInvoicesRedirectComponent,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupBillingInvoicesRedirectRoutingModule {
}


